// extracted by mini-css-extract-plugin
module.exports = {"icon":"PoliciesIcon__icon___1Ta1Z","stroked":"PoliciesIcon__stroked___3SFs0","filled":"PoliciesIcon__filled___1DORU"};